export const generateKey = (viewId: string) => {
  // todo: we need to have mechanism that will generate similar keys for local storage, not to use custom keys anywhere
  return `c8r-${viewId}-resource-explorer-data-grid-view`;
};
